<template>
  <div class="w-full !p-6 bg-primary/5 grid gap-4 rounded-md">
    <span class="text-primary font-bold text-2xl">
      {{
        $t("priceRanges.title", {
          name: $helpers.capitalize(professionTask.name),
        })
      }}
    </span>
    <div class="grid gap-3">
      <div>
        <div
          v-for="(priceRange, index) in priceRanges"
          :key="priceRange.from"
          class="flex justify-between"
        >
          <div class="grid gap-1 grid-cols-3 text-sm">
            <span
              v-for="level in 3"
              :key="level"
              class="font-bold text-primary"
              :class="{ 'opacity-20': level > index + 1 }"
            >
              $
            </span>
          </div>
          <div class="text-typo-primary font-bold text-sm">
            {{ $n(Math.floor(priceRange.from), "currency") }} -
            {{ $n(Math.floor(priceRange.to), "currency") }}
          </div>
        </div>
      </div>
      <p class="text-typo-primary font-semibold leading-normal text-sm">
        {{ $t("priceRanges.text") }}
      </p>
      <JoszakiButton
        href="#szakemberek"
        @click="$trackers.trackClick('PriceRangesShowPricesButton')"
      >
        {{ $t("priceRanges.showRest") }}
      </JoszakiButton>
    </div>
  </div>
</template>

<script>
import JoszakiButton from "~/components/_refactored/common/JoszakiButton.vue";

export default {
  components: { JoszakiButton },
  props: {
    priceRanges: {
      type: Array,
      required: true,
    },
    professionTask: {
      type: Object,
      required: true,
    },
    isBlog: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
